import React from 'react';
import { Mail, Github, Linkedin, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { socialLinks, contactInfo } from '../data/mock';

const ContactSection = () => {
  const socialIcons = [
    { icon: Github, label: 'GitHub', url: socialLinks.github, color: 'hover:text-gray-400' },
    { icon: Linkedin, label: 'LinkedIn', url: socialLinks.linkedin, color: 'hover:text-blue-400' },
    { icon: MessageCircle, label: 'WhatsApp', url: socialLinks.whatsapp, color: 'hover:text-green-400' },
    { icon: Mail, label: 'E-mail', url: socialLinks.email, color: 'hover:text-purple-400' }
  ];

  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-4">
       
        <div className="text-center mb-16 space-y-4">
          <span className="text-blue-400 text-sm font-mono uppercase tracking-wider">Vamos Conversar</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Entre em Contato
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Estou sempre aberto a discutir novos projetos, ideias criativas ou oportunidades
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-1 justify-items-center gap-12">
        
            

            
            <div className="space-y-8">
              <div>
                
                <div className="grid grid-cols-2 gap-4">
                  {socialIcons.map(({ icon: Icon, label, url, color }) => (
                    <Button
                      key={label}
                      onClick={() => window.open(url, '_blank')}
                      variant="outline"
                      className={`border-gray-800 bg-gray-900/50 hover:bg-gray-800 text-white ${color} transition-all duration-200 h-auto py-6 flex-col gap-3`}
                    >
                      <Icon size={24} />
                      <span className="text-sm">{label}</span>
                    </Button>
                  ))}
                </div>
              </div>

              
              <div className=" flex flex-col items-center flex-direction-column bg-gradient-to-br from-blue-500/10 to-purple-600/10 border border-purple-500/20 rounded-lg p-6 space-y-4">
                <h4 className="text-lg font-semibold text-white self-start">Pronto para começar?</h4>
                <p className="text-gray-400 text-sm self-start">
                  Entre em contato e vamos transformar suas ideias em realidade!
                </p>
                <Button
                  onClick={() => window.open(socialLinks.email, '_blank')}
                  className="w-40 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white"
                >
                  <Mail size={16} className="mr-2" />
                  Enviar E-mail
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;